<div class="flex">
  <mat-grid-list
    [cols]="cols"
    gutterSize="5px"
    class="File-grid flex-1"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="sortDrop($event)"
  >
    <mat-grid-tile
      cdkDrag
      class="File-grid__tile"
      [class.opacity-30]="file.localProps?.toDelete"
      *ngFor="let file of $any(files); let i = index"
      [cdkDragData]="file"
      [style.background-image]="
        file.isLocalFile
          ? file.isImage
            ? 'url(' + (file.file | previewLocalImage) + ')'
            : ''
          : file.isImage()
          ? 'url(' + (file.getFilePath({ w: 300 }) | secureImg) + ')'
          : file.isVideo() && file.children?.length
          ? 'url(' + (file.children[0].getFilePath({ w: 300 }) | secureImg) + ')'
          : ''
      "
    >
      <mat-grid-tile-header class="File-grid__tile__header">
        <div class="flex justify-between items-center max-w-full w-full">
          <span class="text-white whitespace-nowrap overflow-hidden overflow-ellipsis" [matTooltip]="file.title || file.file?.name">{{
            file.title || file.file?.name
          }}</span>
          <button mat-icon-button class="flex-none" type="button" (click)="remove(i)">
            <mat-icon>{{ file.localProps?.toDelete ? 'restore_from_trash' : 'delete' }}</mat-icon>
          </button>
        </div>
      </mat-grid-tile-header>
      <mat-icon
        *ngIf="(file.isLocalFile && !file.isImage) || (!file.isLocalFile && !file.isImage())"
        class="text-white !w-12 !h-12 text-5xl"
        >{{ file.mime | fileIcon }}</mat-icon
      >
    </mat-grid-tile>
    <mat-grid-tile
      class="File-grid__tile File-grid__tile--add"
      (click)="addFromSource(allowDirectUpload ? sources.direct : sources.library)"
    >
      <div class="flex flex-col items-center justify-center">
        <mat-icon class="File-grid__tile__icon">add_to_photos</mat-icon>
        <span>{{ 'MEDIA.ADD_FILE' | translate }}</span>
      </div>
    </mat-grid-tile>
    <!-- <mat-grid-tile
      cdkDrag
      class="File-grid__tile"
      *ngFor="let file of localFiles; let i = index"
      [cdkDragData]="file"
      [style.background-image]="file.isImage ? 'url(' + (file.file | previewLocalImage) + ')' : ''"
    >
      <mat-grid-tile-header class="File-grid__tile__header">
        <div class="flex justify-between items-center max-w-full w-full">
          <span class="text-white whitespace-nowrap overflow-hidden overflow-ellipsis" [matTooltip]="file.file.name">{{
            file.file.name
          }}</span>
          <button mat-icon-button class="flex-none" type="button" (click)="remove(file, i)"><mat-icon>delete</mat-icon></button>
        </div>
      </mat-grid-tile-header>
      <mat-icon *ngIf="!file.isImage">{{ file.getIconString() }}</mat-icon>
    </mat-grid-tile>
    <mat-grid-tile class="File-grid__tile File-grid__tile--add" (click)="add()">
      <div class="flex flex-col items-center justify-center">
        <mat-icon class="File-grid__tile__icon">add_to_photos</mat-icon>
        <span>{{ 'MEDIA.ADD_FILE' | translate }}</span>
      </div>
    </mat-grid-tile>
    <mat-grid-tile class="File-grid__tile File-grid__tile--add" *ngIf="!allowDirectUpload" (click)="addFromSource(sources.library)">
      <mat-icon class="File-grid__tile__icon">add_to_photos</mat-icon>
    </mat-grid-tile> -->
  </mat-grid-list>

  <!-- <div class="flex-none w-[200px]" *ngIf="primary">
    <aw-file-primary-image [unit]="unit" [rules]="rules" [control]="primary"></aw-file-primary-image>
  </div> -->
</div>

<mat-menu #sourceMenu="matMenu">
  <button mat-menu-item (click)="addFromSource(sources.library)">
    <mat-icon>image</mat-icon>
    <span>Från mediebiblioteket</span>
  </button>
  <label mat-menu-item>
    <input type="file" class="hidden" ngFileSelect (uploadOutput)="onUploadOutput($event)" multiple />
    <mat-icon>cloud_upload</mat-icon> Ladda upp direkt
  </label>
</mat-menu>
